import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  leadIds: yup.array().of(yup.number().required()).required(),
});

export function useDeleteManyLeadsMutation(options = {}) {
  return useMutation((dto) => {
    const req = requestSchema.validateSync(dto, {
      strict: true,
    });
    return http.delete(HTTP_ENDPOINTS.deleteManyLeads(), {
      data: {
        lead_ids: req.leadIds,
      },
    });
  }, options);
}
